import { typedI18nFactory } from 'utils/typedI18nFactory';

import { en } from './en';
import { ru } from './ru';

export const i18nAviaClass = typedI18nFactory({ ru, en });
